const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const YEAR = 365 * DAY;
const MONTH = YEAR / 12;
const TIME_SECTION_LABELS_DE = [
    'gerade eben',
    'vor einer Minute',
    'vor # Minuten',
    'vor einer Stunde',
    'vor # Stunden',
    'gestern',
    'vorgestern',
    'vor # Tagen',
    'vor einer Woche',
    'vor # Wochen',
    'vor einem Monat',
    'vor # Monaten',
    'vor einem Jahr',
    'vor # Jahren',
];
const germanRelativeDateLabelFormatter = (index, delta) => {
    let text = TIME_SECTION_LABELS_DE[index];
    if (delta < 0) {
        text = text
            .replace("vorgestern", "übermorgen")
            .replace("gestern", "morgen")
            .replace("vor", "in");
    }
    return text;
};
const TIME_SECTIONS = [
    [0.8 * MINUTE],
    [1.5 * MINUTE],
    [60 * MINUTE, MINUTE],
    [1.5 * HOUR],
    [DAY, HOUR],
    [2 * DAY],
    [3 * DAY],
    [7 * DAY, DAY],
    [1.5 * WEEK],
    [MONTH, WEEK],
    [1.5 * MONTH],
    [YEAR, MONTH],
    [1.5 * YEAR],
    [Infinity, YEAR],
];
export function formatRelative(date, referenceDate = null, formatLabel = null) {
    if (null === formatLabel) {
        formatLabel = germanRelativeDateLabelFormatter;
    }
    if (null === referenceDate) {
        referenceDate = new Date();
    }
    const delta = (referenceDate.getTime() - date.getTime()) / 1000;
    const absDelta = Math.abs(delta);
    for (let i = 0; i < TIME_SECTIONS.length; i++) {
        const entry = TIME_SECTIONS[i];
        if (absDelta < entry[0]) {
            const text = formatLabel(i, delta);
            return entry[1] !== undefined
                ? text.replace("#", Math.round(absDelta / entry[1]) + "")
                : text;
        }
    }
    return "";
}
export function formatDate(date) {
    return `${zeroFill(date.getDate())}.${zeroFill(date.getMonth() + 1)}.${date.getFullYear()}`;
}
export function formatDateTime(date, withSeconds = true) {
    return `${formatDate(date)} ${formatTime(date, withSeconds)}`;
}
export function formatDateShort(date) {
    return `${zeroFill(date.getDate())}.${zeroFill(date.getMonth() + 1)}.`;
}
export function formatTime(date, withSeconds = true) {
    let time = `${zeroFill(date.getHours())}:${zeroFill(date.getMinutes())}`;
    if (withSeconds) {
        time += `:${zeroFill(date.getSeconds())}`;
    }
    return time;
}
function zeroFill(value) {
    return value < 10 ? `0${value}` : value + "";
}
